import { ConversationTurn } from '../types/conversation';

/** A turn the agent could not answer. A failed delivery on one response is not this. */
export const hasTurnError = (turn?: ConversationTurn) => Boolean(turn?.metadata.isError);
